document.addEventListener('DOMContentLoaded',()=>{
  const resultRoutes={protect:'/collections/protect',restore:'/collections/restore',prepare:'/collections/prepare',maintain:'/collections/maintain'};
  const homeLinks=[['01',resultRoutes.protect],['02',resultRoutes.restore],['03',resultRoutes.maintain],['04','/collections/all']];
  document.querySelectorAll('.hh-results__grid a').forEach((a,i)=>{if(homeLinks[i])a.href=homeLinks[i][1]});
  document.querySelectorAll('.hc-jump a,.hsc__jumps a').forEach((a)=>{const key=(a.textContent||'').trim().toLowerCase();if(resultRoutes[key])a.href=resultRoutes[key];});

  document.querySelectorAll('.hcc__add button[name="add"],.hcc__sticky button[name="add"],.hgp__add button[name="add"],.hgp__sticky button[name="add"],.hcpd__form-row button[name="add"]').forEach((button)=>{
    if(!button.disabled)button.textContent='Add to cart';
    button.style.background='#64abc3';
    button.setAttribute('data-h-cro-event','add_to_cart');
  });
  document.querySelectorAll('.hcc__close,.hgp__close').forEach((section)=>section.remove());

  const intelligence=document.querySelector('.hrp .hri');
  const diagnosis=document.querySelector('.hrp .hrp__diagnosis');
  if(intelligence&&diagnosis)diagnosis.before(intelligence);

  const cleanReviewLabels=()=>{
    document.querySelectorAll('#judgeme_all_reviews_page a,#judgeme_all_reviews_page h3,#judgeme_all_reviews_page h4,.jdgm-all-reviews-page a,.jdgm-all-reviews-page h3,.jdgm-all-reviews-page h4,.jdgm-rev__title').forEach((el)=>{
      const raw=(el.textContent||'').trim();
      if(/^about\s+/i.test(raw))el.textContent=raw.replace(/^about\s+/i,'');
    });
  };
  cleanReviewLabels();
  const reviewRoot=document.querySelector('#judgeme_all_reviews_page,.jdgm-all-reviews-page,.jdgm-widget');
  if(reviewRoot){new MutationObserver(cleanReviewLabels).observe(reviewRoot,{subtree:true,childList:true,characterData:true});}

  const placeFamilyProof=()=>{
    const near=document.querySelector('[data-review-family-proof][data-review-placement="near-buy"]');
    const mid=document.querySelector('[data-review-family-proof][data-review-placement="mid-page"]');
    const hero=document.querySelector('.hcc__hero,.hgp__hero,.hcpd__hero');
    const longform=document.querySelector('.hcc__proof,.hgp__real,.hgp__details,.hcpd__details,.hcc__method,.hcc__details');
    if(near&&hero&&hero.nextElementSibling!==near)hero.insertAdjacentElement('afterend',near);
    if(mid&&longform&&mid.nextElementSibling!==longform)longform.insertAdjacentElement('beforebegin',mid);
  };
  placeFamilyProof();
  setTimeout(placeFamilyProof,250);
  setTimeout(placeFamilyProof,900);

  const normalizeCopy=(value='')=>String(value).replace(/([a-z0-9)])([A-Z])/g,'$1 $2').replace(/\s+/g,' ').trim();
  const productTitle=normalizeCopy(document.querySelector('.hgp__buy h1,.hcpd__buy h1,h1')?.textContent||'');
  const normaliseLead=(el)=>{
    if(!el)return;
    let text=normalizeCopy(el.textContent||'');
    if(productTitle&&text.toLowerCase().startsWith(`${productTitle.toLowerCase()} `))text=text.slice(productTitle.length).trim();
    el.textContent=text;
  };
  document.querySelectorAll('.hgp__lead,.hcpd__promise').forEach(normaliseLead);
  document.querySelectorAll('.hgp__rte,.hcpd__rte').forEach((rte)=>{
    const firstHeading=rte.querySelector(':scope > h1,:scope > h2,:scope > h3,:scope > h4');
    if(firstHeading&&productTitle&&normalizeCopy(firstHeading.textContent).toLowerCase()===productTitle.toLowerCase())firstHeading.remove();
  });

  document.querySelectorAll('.hgp__details aside span').forEach((el)=>{
    if(/ask hermosa before applying/i.test((el.textContent||'').trim()))el.textContent='Get product help →';
  });

  const rewriteParagraph=(selector,from,to)=>{
    document.querySelectorAll(selector).forEach((el)=>{
      const raw=(el.textContent||'').replace(/\s+/g,' ').trim();
      if(raw===from)el.textContent=to;
    });
  };
  // Product introductions and safety copy are rendered from hermosa-customer-description.
  if(/^\/blogs\/hermosa-blog\/(how-much-does-50-ml-of-ceramic-coating-really-cover|graphene-ceramic-coating-for-marine-applications-what-really-matters)\/?$/.test(location.pathname)){
    document.querySelectorAll('.hjournal__legacy-body img').forEach((img)=>img.style.setProperty('display','block','important'));
  }

  const chooser=document.querySelector('.hcc__packs,.hgp__packs');
  if(chooser){
    chooser.setAttribute('data-h-cro-event','package_selector');
    chooser.setAttribute('data-package-selector','graphene-ceramic-coating');
    chooser.querySelectorAll('a').forEach((a)=>{
      const text=(a.textContent||'').trim();
      if(/^1\s*[×x]/i.test(text))a.setAttribute('data-h-cro-event','package_1');
      if(/^2\s*[×x]/i.test(text))a.setAttribute('data-h-cro-event','package_2');
      if(/^4\s*[×x]/i.test(text))a.setAttribute('data-h-cro-event','package_4');
    });
  }

  const grapheneBundleOffers=[
    {handle:'graphene-ceramic-coating-for-cars-10h-2-pack-bundle-5-year-protection-hermosa-copy',pct:15,event:'graphene_2_pack_15'},
    {handle:'graphene-ceramic-coating-new-50ml-4-pack-bundle-hermosa',pct:25,event:'graphene_4_pack_25'}
  ];
  const bundleOfferFor=(href='')=>grapheneBundleOffers.find((offer)=>href.includes(offer.handle));
  const moneyParts=(raw='')=>{
    const match=String(raw).match(/([^\d-]*)(\d[\d,]*(?:\.\d{1,2})?)/);
    if(!match)return null;
    const amount=Number(match[2].replace(/,/g,''));
    if(!Number.isFinite(amount))return null;
    return {prefix:match[1],amount,base:`${match[1]}${amount.toFixed(2)}`};
  };
  const discountedMoney=(parts,pct)=>`${parts.prefix}${(parts.amount*(1-pct/100)).toFixed(2)}`;
  const applyGrapheneBundleOffers=()=>{
    document.querySelectorAll('.hcc__packs a,.hgp__packs a').forEach((a)=>{
      const href=a.getAttribute('href')||a.getAttribute('data-h-v3-original-href')||'';
      const offer=bundleOfferFor(href);
      if(!offer)return;
      const span=a.querySelector('span');
      if(!span)return;
      const current=span.getAttribute('data-h-offer-base')||span.textContent||'';
      const parts=moneyParts(current);
      if(!parts)return;
      const soldOut=/sold out/i.test((a.textContent||'')+' '+current)||a.getAttribute('aria-disabled')==='true';
      span.setAttribute('data-h-offer-base',parts.base);
      span.setAttribute('data-h-current-offer',offer.event);
      span.innerHTML=`<s>${parts.base}</s> <b>${discountedMoney(parts,offer.pct)}</b><br><small>${offer.pct}% off automatically at cart${soldOut?' · Sold out':''}</small>`;
      a.setAttribute('data-h-current-offer',offer.event);
    });

    const bundlePath=grapheneBundleOffers.find((offer)=>location.pathname.includes(offer.handle));
    const price=document.querySelector('.hbp__price');
    if(bundlePath&&price){
      const strong=price.querySelector(':scope > strong');
      const raw=strong?.getAttribute('data-h-offer-base')||strong?.textContent||'';
      const parts=moneyParts(raw);
      if(parts){
        const effective=discountedMoney(parts,bundlePath.pct);
        price.setAttribute('data-h-current-offer',bundlePath.event);
        price.innerHTML=`<strong data-h-offer-base="${parts.base}">${effective}</strong><s>${parts.base}</s><span>${bundlePath.pct}% automatic bundle saving</span>`;
        const sticky=document.querySelector('.hbp__sticky b');
        if(sticky){sticky.textContent=effective;sticky.setAttribute('title',`Regular pack price ${parts.base}; ${bundlePath.pct}% automatic discount applied at cart`);}
        document.querySelectorAll('.hbp__details p').forEach((el)=>{
          if(/Any saving is shown only when a current compare-at price exists in Shopify\./.test(el.textContent||'')){
            el.textContent=(el.textContent||'').replace(/The price shown above is the current Shopify price for the full pack\. Any saving is shown only when a current compare-at price exists in Shopify\./,`The regular pack price is ${parts.base}. The ${bundlePath.pct}% automatic bundle saving shown above is applied by Shopify at cart/checkout while the current offer remains active.`);
          }
        });
      }
    }
  };
  applyGrapheneBundleOffers();

  document.querySelectorAll('a[href*="hermosa-graphene-ceramic-coating-guide"],.hgp__links a[href*="guide"],.hcpd__links a[href*="guide"]').forEach((a)=>a.setAttribute('data-h-cro-event','application_guide'));
  document.querySelectorAll('a[href^="#reviews"],a[href="/pages/reviews"]').forEach((a)=>a.setAttribute('data-h-cro-event','review_interaction'));

  const clarityEvent=(name)=>{if(typeof window.clarity==='function')window.clarity('event',`v3_${name}`)};
  if(/^\/products\//.test(location.pathname)){
    if(typeof window.clarity==='function')window.clarity('set','v3_route',location.pathname);
    clarityEvent('pdp_view');
  }
  document.addEventListener('click',(event)=>{
    const target=event.target.closest('[data-h-cro-event]');
    if(!target)return;
    const name=target.getAttribute('data-h-cro-event');
    if(/^package_[124]$/.test(name))clarityEvent('package_selector');
    clarityEvent(name);
  });
  const reviewExposure=document.querySelector('[data-h-cro-event="review_exposure"]');
  if(reviewExposure&&'IntersectionObserver'in window){
    let seen=false;
    new IntersectionObserver((entries)=>entries.forEach((entry)=>{if(entry.isIntersecting&&!seen){seen=true;clarityEvent('review_exposure')}}),{threshold:.35}).observe(reviewExposure);
  }
  const scrollSeen={25:false,50:false,75:false,90:false};
  addEventListener('scroll',()=>{
    const root=document.documentElement;
    const max=Math.max(1,root.scrollHeight-innerHeight);
    const pct=Math.round(scrollY/max*100);
    [25,50,75,90].forEach((mark)=>{if(!scrollSeen[mark]&&pct>=mark){scrollSeen[mark]=true;clarityEvent(`scroll_${mark}`)}});
  },{passive:true});

  if(/\/products\/hermosa-graphene-ceramic-coating-50ml\/?$/.test(location.pathname)){
    [...document.querySelectorAll('main section,main>div,#MainContent>div')].forEach((section)=>{
      if(section.closest('.hcc'))return;
      const links=[...section.querySelectorAll('a[href*="/products/"]')];
      const coatingPacks=links.filter((a)=>/graphene ceramic coating/i.test((a.textContent||''))&&/(2\s*pack|4\s*pack|2\s*[x×]|4\s*[x×]|50ml bottle)/i.test((a.textContent||'')));
      if(coatingPacks.length>=2)section.remove();
    });
  }
});

// Founder-visible obviousness + canonical Graphene review-family reconciliation.
document.addEventListener('DOMContentLoaded',()=>{
  const removeEscapedNewlineArtifacts=(root=document)=>{
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const stale=[];
    let node;
    while((node=walker.nextNode())){
      const parent=node.parentElement;
      if(!parent||/^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|TEXTAREA|PRE|CODE)$/i.test(parent.tagName))continue;
      if((node.nodeValue||'').trim()==='\\n')stale.push(node);
    }
    stale.forEach((textNode)=>textNode.remove());
  };
  const repairObviousness=()=>{
    removeEscapedNewlineArtifacts();
  };
  repairObviousness();
  [250,900,1800,3000].forEach((delay)=>setTimeout(repairObviousness,delay));
});

(() => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const updateAnchorOffset = () => {
    document.documentElement.style.setProperty('--h-anchor-offset', Math.ceil(header.getBoundingClientRect().height + 16) + 'px');
  };
  updateAnchorOffset();
  if ('ResizeObserver' in window) new ResizeObserver(updateAnchorOffset).observe(header);
  else window.addEventListener('resize', updateAnchorOffset, {passive:true});
})();

// Resolve an initial fragment after product proof placement, images and fonts settle.
// Never override Back/Forward restoration or a reader who has begun interacting.
(() => {
  const initialHash = window.location.hash;
  if (!initialHash || initialHash === '#') return;
  const navigation = window.performance?.getEntriesByType('navigation')[0];
  if (navigation?.type === 'back_forward') return;
  let cancelled = false;
  const cancel = () => { cancelled = true; };
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((name) =>
    window.addEventListener(name, cancel, {once:true, passive:true}));
  const align = () => {
    if (cancelled || window.location.hash !== initialHash) return;
    let id;
    try { id = decodeURIComponent(initialHash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id);
    if (!target) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (!cancelled && window.location.hash === initialHash)
        target.scrollIntoView({block:'start', behavior:'instant'});
    }));
  };
  const ready = () => {
    align();
    if (document.fonts?.ready) document.fonts.ready.then(align);
  };
  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready, {once:true});
})();

// Preserve mobile footer disclosure state when returning through browser history.
(() => {
  const key = '__hermosaFooterReturn';
  const selector = 'footer button[aria-controls^="Footer-"]';
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('footer a[href]');
    if (!link || !isMobile() || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname === location.pathname &&
        url.search === location.search) return;
    const open = Array.from(document.querySelectorAll(selector))
      .filter(button => button.getAttribute('aria-expanded') === 'true')
      .map(button => button.getAttribute('aria-controls'));
    try {
      history.replaceState({...history.state, [key]: {url:location.href, y:scrollY, open}}, '');
    } catch (_) { /* Native history remains available when state cannot be saved. */ }
  });
  const saved = history.state?.[key];
  if (!saved || saved.url !== location.href || !isMobile() ||
      performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
  let cancelled = false;
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name =>
    window.addEventListener(name, () => { cancelled = true; }, {once:true, passive:true}));
  const restorePanels = () => {
    if (cancelled || !isMobile()) return;
    document.querySelectorAll(selector).forEach(button => {
      const id = button.getAttribute('aria-controls');
      const panel = document.getElementById(id);
      if (!panel) return;
      const open = saved.open.includes(id);
      button.setAttribute('aria-expanded', String(open));
      button.classList.toggle('is-open', open);
      panel.classList.toggle('is-open', open);
      if (open) panel.classList.remove('hide');
      panel.style.height = open ? 'auto' : '0px';
    });
  };
  const align = () => requestAnimationFrame(() => requestAnimationFrame(() => {
    if (!cancelled && isMobile()) window.scrollTo({top:saved.y, behavior:'instant'});
  }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restorePanels, {once:true});
  else restorePanels();
  const ready = () => { restorePanels(); align(); if (document.fonts?.ready) document.fonts.ready.then(align); };
  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready, {once:true});
})();

// Keep Judge.me's body-unlock scroll restoration instantaneous.
(function () {
  function initReviewViewerScroll() {
    const root = document.documentElement;
    const body = document.body;
    let saved = null;
    let restoreFrame = 0;
    function sync() {
      if (body.classList.contains('jm-mfp-is-open')) {
        if (restoreFrame) cancelAnimationFrame(restoreFrame);
        restoreFrame = 0;
        if (!saved) {
          saved = {value: root.style.getPropertyValue('scroll-behavior'), priority: root.style.getPropertyPriority('scroll-behavior')};
          root.style.setProperty('scroll-behavior', 'auto', 'important');
        }
        return;
      }
      if (!saved) return;
      if (restoreFrame) cancelAnimationFrame(restoreFrame);
      restoreFrame = requestAnimationFrame(function () {
        restoreFrame = requestAnimationFrame(function () {
          restoreFrame = 0;
          if (body.classList.contains('jm-mfp-is-open')) return;
          if (root.style.getPropertyValue('scroll-behavior') === 'auto' && root.style.getPropertyPriority('scroll-behavior') === 'important') {
            if (saved.value) root.style.setProperty('scroll-behavior', saved.value, saved.priority);
            else root.style.removeProperty('scroll-behavior');
          }
          saved = null;
        });
      });
    }
    new MutationObserver(sync).observe(body, {attributes: true, attributeFilter: ['class']});
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviewViewerScroll, {once: true});
  else initReviewViewerScroll();
})();
